import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import AppCard from 'components/@common/Cards/AppCard';
import useAppAccess from 'hooks/use-app-access';
import { ProductType } from 'types/schema-generated-types';
import { LicenseStatus } from 'types/enums';

const TeacherApplicationInformation = () => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation('TeacherApplicationInformation');
  const [{ apps }] = useAppAccess({
    statuses: [LicenseStatus.FULL, LicenseStatus.AUDITOR, LicenseStatus.TRIAL],
    types: [ProductType.USER]
  });

  return (
    <>
      <div className={classes.titleContainer}>
        <Typography variant="h2" className={classes.title}>
          {t('Teacher Applications')}
        </Typography>
        <Button
          onClick={() => history.push('/app-access')}
          variant="outlined"
          size="small"
          disableElevation
          startIcon={<ArrowForwardIcon />}
        >
          {t('View All Applications')}
        </Button>
      </div>
      <div className={classes.cardContainer}>
        {apps.map(({ pliManagedApp, status, dateExpiration }) => {
          const app = pliManagedApp.app;
          const product = pliManagedApp.appProduct?.product;

          const key = product ? `app-${app.id}-${product.id}` : `app-${app.id}`;
          const url =
            pliManagedApp.accessDetails?.url ?? `/app-access/${product?.code ?? app.name}`;

          return (
            <AppCard
              key={key}
              href={url}
              className={classes.card}
              openNew={!!pliManagedApp.accessDetails?.url}
              src={pliManagedApp.accessDetails?.bannerUrl}
              title={pliManagedApp.title}
              mediaProps={{ className: classes.media }}
              status={status}
              dateExpiration={dateExpiration}
            />
          );
        })}
      </div>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(1.5)
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  cardContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: '30px'
  },
  card: {
    cursor: 'pointer',
    width: '288px'
  },
  media: {
    height: theme.typography.pxToRem(152),
    maxWidth: '100%',
    marginBottom: theme.spacing(0.5),
    backgroundImage: 'linear-gradient(180deg, #FFFFFF 0%, #EEEEEE 100%)'
  }
}));

export default TeacherApplicationInformation;
